import React, { useEffect, useState } from "react";
import Tabs from "../../components/Tabs/Tabs";
import FailureDetailsTab from "./FailureDetailsTab";
import FailureVersionHistoryTab from "./FailureVersionHistoryTab";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button } from "../../components/Button/Button";
import "./FailureTabs.custom.css";
import FailureAttachmentsTab from "./FailureAttachmentsTab";
import { useNavigate, useParams } from "react-router-dom";
import FailureListActionPlanTab from "./FailureListActionPlanTab";

const tabMap = ["details", "action-plans", "attachments", "versions"];

const FailureTabs: React.FC = () => {
  const { fmeaId, failureId, tab = "details" } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("menu");

  const [activeIndex, setActiveIndex] = useState(tabMap.indexOf(tab));

  useEffect(() => {
    const currentIndex = tabMap.indexOf(tab);
    if (currentIndex !== activeIndex) {
      setActiveIndex(currentIndex >= 0 ? currentIndex : 0);
    }
  }, [tab]);

  const handleTabChange = (index: number): void => {
    const selectedTab = tabMap[index] || "details";
    navigate(`/fmeas/${fmeaId}/failures/${failureId}/${selectedTab}`);
    setActiveIndex(index);
  };

  return (
    <div className="overflow-hidden">
      <PageHeader
        title={t("failure") || "Falha"}
        description={t("failureDescription") || "Gerencie os detalhes, planos de ação, anexos e histórico desta falha"}
      >
        <Button
          label={t("back") || "Voltar"}
          icon="arrow_back"
          severity="secondary"
          variant="text"
          onClick={() => navigate(`/fmeas/${fmeaId}/failures`)}
        />
      </PageHeader>

      <div className="p-4 flex flex-column gap-4">
        <Tabs activeIndex={activeIndex} onChange={handleTabChange}>
          <Tabs.List>
            <Tabs.Tab label={t("details")} icon="info" />
            <Tabs.Tab label={t("listActionPlans")} icon="checklist" />
            <Tabs.Tab label={t("attachments")} icon="attach_file" />
            <Tabs.Tab label={t("versions")} icon="history" />
          </Tabs.List>
          
          <Tabs.Panels>
            <Tabs.Panel>
              <FailureDetailsTab />
            </Tabs.Panel>
            <Tabs.Panel>
              <FailureListActionPlanTab />
            </Tabs.Panel>
            <Tabs.Panel>
              <FailureAttachmentsTab />
            </Tabs.Panel>
            <Tabs.Panel>
              <FailureVersionHistoryTab />
            </Tabs.Panel>
          </Tabs.Panels>
        </Tabs>
      </div>
    </div>
  );
};

export default FailureTabs;
